import { render } from "./EducationModal.vue?vue&type=template&id=eab82e2a&scoped=true"
import script from "./EducationModal.vue?vue&type=script&lang=js"
export * from "./EducationModal.vue?vue&type=script&lang=js"

import "./EducationModal.vue?vue&type=style&index=0&id=eab82e2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eab82e2a"]])

export default __exports__